import { Button, ButtonGroup } from '@theswing/rhythm';

import { PageContainer } from '@/components/common/PageContainer';
import { ContentContainer, GuideContainer, SectionContainer, TitleContainer } from './components/Container';
import { HorizontalDivider } from '@/components/common/HorizontalDivider';

interface Guide {
  title: string;
  content: string;
}

export function PastUsed() {

  const guideList: Guide[] = [
    {
      title: '옛날에 이용했던 건데 왜 갑자기 결제하나요?',
      content:
        '고객님의 지난 스윙 라이드 후, 결제 완료되지 않은 미납 건에 대한 정산입니다. 당시 결제 실패된 내역을 정산 진행 중에 있으니 양해 부탁드립니다.',
    },
    {
      title: '마지막 이용 일시에 스윙을 이용하지 않았어요.',
      content:
        '친구, 지인 등 다른 사람에게 카드를 빌려주거나 스윙 계정을 공유한 적이 있는지 확인해 주세요. 본인 혹은 지인이 사용한 적이 없다면 카드사 혹은 수사기관에 문의해 주세요. \(*스윙 고객센터에서 안내드리기 어렵습니다.\)'
    },
    {
      title: '다시 결제를 시도하고 싶어요.',
      content: '결제는 스윙 앱에서 처리할 수 있습니다.'
    },
    {
      title: '결제수단을 변경하고 싶어요.',
      content: `결제 수단은 \[SWING 앱 \> 더보기 탭 \> 결제수단 선택 \> 결제수단 등록 선택\]을 통해 변경할 수 있습니다.\n\n* 현재 문의량이 많아 전화 안내가 어렵습니다. 채팅 문의를 남겨주시면 순차적으로 안내 도와드리겠습니다.`
    }
  ];

  return (
    <PageContainer>
      <PageContainer.Content isScrollable={true}>
        <ContentContainer>
          <TitleContainer>
            <div className={'title'}>
              <p className={'sub'}>SWING</p>
              <p className={'main'}>결제 관련 FAQ</p>
            </div>
          </TitleContainer>
          <HorizontalDivider type={'line'} gap={20} />
          <SectionContainer>
            {guideList.map((e, i) => (
              <GuideContainer key={i}>
                <p className={'title'}>{e.title}</p>
                <p className={'content'}>{e.content}</p>
              </GuideContainer>
            ))}
          </SectionContainer>
        </ContentContainer>
        <PageContainer.ButtonContainer>
          <ButtonGroup variant={'1-b'}>
            <Button variant={'tertiary'} onClick={() => window.location.href = 'https://tswm.link/landing?type=route'}>
              재결제 하러 가기
            </Button>
          </ButtonGroup>
        </PageContainer.ButtonContainer>
      </PageContainer.Content>
    </PageContainer>
  );
}